module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "play.64bc09cf.svg";